module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1148.10f05439.png";